import type { ReactNode } from 'react';
import type { CategoryProfile } from '@/lib/types/division-profile';
import type { LucideIcon } from 'lucide-react';
import { SlotCostGrid } from '@/components/SlotCostGrid';

interface CategoryRowProps {
  label: string;
  icon: LucideIcon;
  profile: CategoryProfile;
  children: ReactNode;
}

export function CategoryRow({
  label,
  icon: Icon,
  profile,
  children,
}: CategoryRowProps) {
  return (
    <div className="rounded-xl border bg-card text-card-foreground shadow-sm overflow-hidden">
      <div className="px-2 py-1 border-b bg-muted/30">
        <div className="flex items-center justify-between gap-2">
          <div className="flex items-center gap-2">
            <Icon className="h-4 w-4 text-muted-foreground" />
            <h3 className="text-sm font-semibold uppercase tracking-wider">
              {label}
            </h3>
          </div>
          <SlotCostGrid costs={profile.slots.activationCosts} />
        </div>
        <CpSpreadLine profile={profile} />
      </div>

      <div className="px-2 pb-1.5 pt-1.5 space-y-1.5">
        {children}
      </div>
    </div>
  );
}

function CpSpreadLine({ profile }: { profile: CategoryProfile }) {
  const { cpSpread, packCount } = profile;

  if (cpSpread.unitCount === 0) {
    return (
      <p className="text-xs text-muted-foreground italic mt-0.5">
        No units available
      </p>
    );
  }

  return (
    <p className="text-xs text-muted-foreground mt-0.5 tabular-nums">
      {packCount} units · CP {cpSpread.min}–{cpSpread.max} avg {cpSpread.average}
    </p>
  );
}
